<template>
  <div class="tw-text-[#353535] tw-text-[26px] tw-leading-snug tw-font-roboto tw-ml-[5px]">
    <slot />
  </div>
</template>

